<div
    class="channel-table-row-background channel-table-row text"
    #channelWrap
    [class.disabled]="disabled"
>
    <div class="alarm-bg-wrapper" [ngClass]="ngClass">
        <div
        data-cy="channel-group-channel-list-channel-number"
            class="col-ch-no opaque"
        >
            {{ channel.opsData.tag }}
        </div>
        <div
        data-cy="channel-group-channel-list-channel-name"
            class="col-ch-name opaque"
        >
            {{ channel.opsData.name }}
        </div>
        <div class="col-value opaque">
            <div data-cy="channel-group-channel-list-channel-value">
                {{ getValueString() }}
            </div>
            <div
            data-cy="channel-group-channel-list-channel-value-unit"
            >
                {{ measurementUnit }}
            </div>
        </div>
        <div
        data-cy="channel-group-channel-list-channel-status"
            class="col-status opaque"
            alarmLevelColor
            [channel]="channel"
            [status]="status"
        >
            {{ statusString | translate }}
        </div>
        <div data-cy="channel-group-channel-list-channel-range" class="col-range" #range>
            <div class="col-range-content" *ngIf="!isDigital">
                <app-channel-alarm-range
                    *ngIf="!disabled"
                    [channel]="channel"
                    [value]="channelValue"
                    [status]="status"
                ></app-channel-alarm-range>
            </div>
        </div>
    </div>
</div>
